import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from 'helpers/api'
import { toast } from "react-toastify";
import { t } from 'i18next';

export const getTerms = createAsyncThunk('terms/list', async (_, { dispatch }) => {
  try {
    const response = await api.get("mobile/terms/list");
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

const initialState = {
  list: false,
  selected: false,
};

export const termsSlice = createSlice({
  name: "terms",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getTerms.fulfilled, (state, action) => {
      state.list = action.payload?.Data
    })
  }
});

export default termsSlice.reducer;